export default "__VITE_ASSET__D9Lv6o_v__"